"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-3e3fe328"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "chat-window" };
var _hoisted_2 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("audio", {
    crossorigin: "anonymous",
    id: "audioPlayer"
}, null, -1); });
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", {
    class: "pi pi-comments",
    style: { "color": "white", "font-size": "1.5rem" }
}, null, -1); });
var _hoisted_4 = {
    class: "text-l text-bold m-2 ml-3",
    style: { "color": "white" }
};
var _hoisted_5 = {
    class: "flex",
    style: { "color": "white" }
};
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", {
    class: "pi pi-window-maximize",
    style: { "font-size": "1rem" }
}, null, -1); });
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", { class: "pi pi-window-minimize" }, null, -1); });
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", {
    class: "pi pi-times mr-2",
    style: { "font-size": "1.0rem" }
}, null, -1); });
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = { style: { "display": "flex", "align-items": "center" } };
var _hoisted_11 = {
    key: 0,
    class: "cursor",
    style: { "display": "flex", "align-items": "center" }
};
var _hoisted_12 = {
    key: 1,
    class: "status-text",
    style: { "display": "flex", "align-items": "center" }
};
var _hoisted_13 = ["id"];
var _hoisted_14 = ["id"];
var _hoisted_15 = {
    key: 1,
    class: "flex flex-wrap mt-3 mb-2"
};
var _hoisted_16 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", null, "Citations:", -1); });
var _hoisted_17 = { id: "citationList" };
var _hoisted_18 = ["onClick"];
var _hoisted_19 = ["href", "innerHTML"];
var _hoisted_20 = {
    key: 2,
    class: "flex flex-row flex-wrap gap-2 mt-4"
};
var _hoisted_21 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", null, "Follow-up questions:", -1); });
var _hoisted_22 = {
    key: 0,
    class: "flex justify-content-center p-1"
};
var _hoisted_23 = {
    class: "flex w-12",
    style: { "position": "relative" }
};
var _hoisted_24 = { class: "flex flex-column gap-1" };
var _hoisted_25 = {
    key: 1,
    class: "flex justify-content-center"
};
var _hoisted_26 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("a", {
    href: "https://chatbot.aspiireai.com",
    target: "_blank",
    style: { "color": "var(--bluegray-400)" }
}, "powered by aspiire chatbot", -1); });
var _hoisted_27 = [
    _hoisted_26
];
var _hoisted_28 = {
    key: 1,
    class: "flex justify-content-center align-items-center",
    style: { "height": "100vh" }
};
var _hoisted_29 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", null, "reCaptcha Failed. Please reload the page and try again.", -1); });
var _hoisted_30 = {
    key: 2,
    class: "flex justify-content-center align-items-center",
    style: { "height": "100vh" }
};
var _hoisted_31 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("span", {
    class: "text-xl",
    style: { "color": "var(--primary-color)" }
}, "You need a valid key to access the chatbot.", -1); });
var _hoisted_32 = [
    _hoisted_31
];
var vue_3 = require("vue");
var auth_1 = require("firebase/auth");
var vuefire_1 = require("vuefire");
var sse_js_1 = require("sse.js");
var firestore_1 = require("firebase/firestore");
var marked_1 = require("marked");
// import { getAppCheck } from 'firebase-admin/app-check';
// import hark from 'hark';
var primaryColorLight = 'rgba(22, 80, 156, 0.16)';
var FOLLOW_UP_MARKER = '[[[';
exports.default = (0, vue_1.defineComponent)({
    __name: 'ChatWindow',
    setup: function (__props) {
        var _this = this;
        var instance = (0, vue_3.getCurrentInstance)();
        var user = (0, vuefire_1.useCurrentUser)();
        var isMobile = (0, vue_3.ref)(false);
        checkIfMobile();
        var botId = instance === null || instance === void 0 ? void 0 : instance.appContext.config.globalProperties.$botId;
        var embed = instance === null || instance === void 0 ? void 0 : instance.appContext.config.globalProperties.$embed;
        var minimized = (instance === null || instance === void 0 ? void 0 : instance.appContext.config.globalProperties.$minimized) ?
            instance === null || instance === void 0 ? void 0 : instance.appContext.config.globalProperties.$minimized :
            (isMobile.value ? true : false);
        var context = (0, vue_3.ref)(instance === null || instance === void 0 ? void 0 : instance.appContext.config.globalProperties.$context);
        var initialUserMessage = instance === null || instance === void 0 ? void 0 : instance.appContext.config.globalProperties.$initialUserMessage;
        var baseUrl;
        if (import.meta.env) {
            baseUrl = import.meta.env.VITE_PAN_API_BASE_URL;
        }
        else {
            baseUrl = process.env.VUE_APP_PAN_API_BASE_URL || '';
        }
        var url = "".concat(baseUrl, "/chat-bots/").concat(botId);
        var primaryColor = (0, vue_3.ref)('#FFFFFF');
        // const primaryColor = 'rgb(22, 80, 156)';
        var responseStatus = (0, vue_3.ref)('in_progress');
        var FOLLOW_UP_MARKER_PREFIX_LENGTH = FOLLOW_UP_MARKER.length - 1;
        var invalidBotId = (0, vue_3.ref)(false);
        var appCheckFailed = (0, vue_3.ref)(false);
        var title = (0, vue_3.ref)('');
        var chatbot = (0, vue_3.ref)();
        var messages = (0, vue_3.ref)([]);
        var smallScreen = (0, vue_3.ref)(window.innerWidth < 768);
        var showCursor = (0, vue_3.ref)(false);
        var isScrolledToBottom = (0, vue_3.ref)(true);
        var disableSend = (0, vue_3.ref)(true);
        var streamResponseDone = (0, vue_3.ref)(true);
        var typingMsgBuffer = (0, vue_3.ref)('');
        var flushTypingMsgBuffer = (0, vue_3.ref)(false);
        var newMessage = (0, vue_3.ref)('');
        var chatMessages = (0, vue_3.ref)(null);
        var chatViewSize = (0, vue_3.ref)();
        var chatViewHidden = (0, vue_3.ref)(minimized);
        var systemMessage = (0, vue_3.ref)();
        var auth = (0, auth_1.getAuth)();
        var signInAttempted = (0, vue_3.ref)(false);
        var appEl = document.getElementById('app');
        // const speech = ref<hark.Harker>();
        var mediaRecorder = (0, vue_3.ref)();
        var audioEnabled = (0, vue_3.ref)(false);
        var styleButtonToggleAudio = (0, vue_3.computed)(function () {
            return __assign(__assign({ color: audioEnabled.value ? 'white' : primaryColor }, !audioEnabled.value && { 'background-color': 'white' }), !audioEnabled.value && { 'border-color': primaryColor });
        });
        var audioStatus = (0, vue_3.ref)('idle');
        if (appEl) {
            appEl.style.setProperty('position', 'fixed');
            appEl.style.setProperty('width', '100%');
            appEl.style.setProperty('height', '100%');
        }
        (0, auth_1.onAuthStateChanged)(auth, function (user) { return __awaiter(_this, void 0, void 0, function () {
            var db, settingsDoc, headerTitleEl, faviconEl, welcomeMsg;
            var _a, _b, _c, _d, _e, _f, _g;
            var _h, _j, _k, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        if (!user) return [3 /*break*/, 3];
                        db = (0, firestore_1.getFirestore)();
                        return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(db, 'chatBots', botId))];
                    case 1:
                        settingsDoc = _m.sent();
                        if (!settingsDoc.exists() || !settingsDoc.data()) {
                            invalidBotId.value = true;
                            return [2 /*return*/];
                        }
                        chatbot.value = settingsDoc.data();
                        title.value = chatbot.value.settings.name;
                        (_a = (_h = chatbot.value).settings) !== null && _a !== void 0 ? _a : (_h.settings = {});
                        (_b = (_j = chatbot.value.settings).citations) !== null && _b !== void 0 ? _b : (_j.citations = true);
                        (_c = (_k = chatbot.value.settings).feedback) !== null && _c !== void 0 ? _c : (_k.feedback = true);
                        (_d = (_l = chatbot.value.settings).followUpQuestions) !== null && _d !== void 0 ? _d : (_l.followUpQuestions = true);
                        primaryColor.value = chatbot.value.settings.color ? "#".concat(chatbot.value.settings.color) : '#16509c';
                        headerTitleEl = document.getElementById('header-title');
                        if (headerTitleEl) {
                            headerTitleEl.innerHTML = title.value;
                        }
                        faviconEl = document.getElementById('favicon');
                        if (faviconEl) {
                            faviconEl.setAttribute('href', ((_f = (_e = chatbot.value) === null || _e === void 0 ? void 0 : _e.settings) === null || _f === void 0 ? void 0 : _f.favicon) || '/favicon.ico');
                        }
                        return [4 /*yield*/, loadHistory()];
                    case 2:
                        _m.sent();
                        if (!((_g = context.value) === null || _g === void 0 ? void 0 : _g.hideWelcomeMessage)) {
                            welcomeMsg = chatbot.value.settings.welcomeMessage ? chatbot.value.settings.welcomeMessage : "Welcome to the ".concat(title.value, ".");
                            messages.value.unshift({
                                content: welcomeMsg,
                                role: 'assistant',
                                id: messages.value.length,
                            });
                        }
                        scrollToBottom(true);
                        disableSend.value = false;
                        if (initialUserMessage) {
                            sendMessage(initialUserMessage);
                        }
                        return [3 /*break*/, 6];
                    case 3:
                        if (!!signInAttempted.value) return [3 /*break*/, 5];
                        return [4 /*yield*/, signIn()];
                    case 4:
                        _m.sent();
                        signInAttempted.value = true;
                        return [3 /*break*/, 6];
                    case 5:
                        systemMessage.value = {
                            content: 'Failed to connect to chatbot.',
                            type: 'error',
                        };
                        _m.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); });
        function setCookie(name, value) {
            document.cookie = "".concat(name, "=").concat(value, "; path=/");
        }
        function getCookie(name) {
            var cookie = document.cookie.split(';').find(function (c) { return c.includes(name); });
            return cookie === null || cookie === void 0 ? void 0 : cookie.split('=')[1];
        }
        function loadHistory() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                function removeQuestions(msg) {
                    return msg.split(FOLLOW_UP_MARKER)[0];
                }
                var db, uid, historyCol, maxAge, historyQuery, historySnap;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if ((_a = context.value) === null || _a === void 0 ? void 0 : _a.disableHistory) {
                                return [2 /*return*/];
                            }
                            db = (0, firestore_1.getFirestore)();
                            uid = (_b = auth.currentUser) === null || _b === void 0 ? void 0 : _b.uid;
                            historyCol = (0, firestore_1.collection)(db, "chatBots/".concat(botId, "/history"));
                            maxAge = firestore_1.Timestamp.fromDate(new Date(Date.now() - 1000 * 60 * 60 * 24));
                            historyQuery = (0, firestore_1.query)(historyCol, (0, firestore_1.orderBy)('timestamp', 'desc'), (0, firestore_1.where)('uid', '==', uid), (0, firestore_1.where)('timestamp', '>=', maxAge));
                            return [4 /*yield*/, (0, firestore_1.getDocs)(historyQuery)];
                        case 1:
                            historySnap = _c.sent();
                            historySnap.forEach(function (doc) {
                                var _a = doc.data(), content = _a.content, role = _a.role, citations = _a.citations, questions = _a.questions;
                                var usedCitations = citations === null || citations === void 0 ? void 0 : citations.filter(function (c) { return c.used; }).filter(function (c) { return c.title; }).filter(function (c) { return c.url && c.url.length > 0; });
                                usedCitations = usedCitations === null || usedCitations === void 0 ? void 0 : usedCitations.map(function (c) {
                                    return {
                                        title: c.title,
                                        url: ensureUrlStartsWithHttps(c.url),
                                        content: c.content,
                                        filepath: c.filepath,
                                    };
                                });
                                usedCitations = removeDuplicateCitations(usedCitations);
                                messages.value.unshift({
                                    content: removeQuestions(content),
                                    messaggeId: doc.id,
                                    role: role,
                                    id: messages.value.length,
                                    streamResponseDone: true,
                                    citations: usedCitations,
                                    followUpQuestions: questions,
                                });
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
        function sendMessage(question) {
            var _a;
            if (!streamResponseDone.value) {
                return;
            }
            systemMessage.value = undefined;
            if (question) {
                newMessage.value = question;
            }
            if (newMessage.value.trim() !== '') {
                var messageHistoryIds = (_a = messages.value) === null || _a === void 0 ? void 0 : _a.filter(function (m) { return m.messaggeId; }).map(function (m) { return m.messaggeId; });
                messages.value.push({
                    content: newMessage.value,
                    role: 'user',
                    id: messages.value.length,
                    streamResponseDone: false
                });
                var msg = newMessage.value;
                streamResponse(msg, messageHistoryIds);
                newMessage.value = ''; // Clear input field after sending a message
                scrollToBottom(true);
            }
        }
        function streamResponse(message, messageHistoryIds) {
            var _a, _b;
            if (messageHistoryIds === void 0) { messageHistoryIds = []; }
            return __awaiter(this, void 0, void 0, function () {
                var msgIndex, source, _c, _d, _e, _f, typeIndex, followUpQuestionStart, followUpQuestions, citations, typingTimer, pendingFollowUpMarkerFragment, stopTypingLoop, ensureTypingLoop;
                var _g, _h;
                var _this = this;
                return __generator(this, function (_j) {
                    switch (_j.label) {
                        case 0:
                            msgIndex = messages.value.push({
                                content: '',
                                role: 'assistant',
                                id: messages.value.length,
                                streamResponseDone: false
                            }) - 1;
                            showCursor.value = true;
                            _c = sse_js_1.SSE.bind;
                            _d = [void 0, url];
                            _g = {};
                            _h = {
                                'Content-Type': 'application/json'
                            };
                            _e = 'Authorization';
                            _f = 'Bearer ';
                            return [4 /*yield*/, ((_a = user.value) === null || _a === void 0 ? void 0 : _a.getIdToken())];
                        case 1:
                            source = new (_c.apply(sse_js_1.SSE, _d.concat([(_g.headers = (_h[_e] = _f + (_j.sent()),
                                    _h),
                                    _g.payload = JSON.stringify(__assign(__assign({ content: message }, ((messageHistoryIds === null || messageHistoryIds === void 0 ? void 0 : messageHistoryIds.length) && { messageHistoryIds: messageHistoryIds })), (((_b = context.value) === null || _b === void 0 ? void 0 : _b.contextMessage) && { contextMessage: context.value.contextMessage }))),
                                    _g)])))();
                            typeIndex = 0;
                            followUpQuestionStart = false;
                            streamResponseDone.value = false;
                            followUpQuestions = '';
                            citations = [];
                            typingTimer = null;
                            pendingFollowUpMarkerFragment = '';
                            stopTypingLoop = function () {
                                if (typingTimer !== null) {
                                    clearTimeout(typingTimer);
                                    typingTimer = null;
                                }
                            };
                            ensureTypingLoop = function () {
                                if (typingTimer !== null) {
                                    return;
                                }
                                var step = function () {
                                    if (typeIndex < typingMsgBuffer.value.length) {
                                        typeOneChar(typeIndex, typingMsgBuffer.value, msgIndex);
                                        typeIndex += 1;
                                        scrollToBottom();
                                        typingTimer = window.setTimeout(step, 20);
                                    }
                                    else {
                                        typingTimer = null;
                                    }
                                };
                                step();
                            };
                            source.addEventListener('message', function (e) { return __awaiter(_this, void 0, void 0, function () {
                                var content, delta, combinedDelta, markerIndex, carryLength, error_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 5, , 6]);
                                            if (!(e.data !== '[DONE]')) return [3 /*break*/, 1];
                                            content = JSON.parse(e.data || '{}');
                                            // console.log('Content', content);
                                            if (content.delta) {
                                                showCursor.value = false;
                                                delta = content.delta;
                                                if (delta == ' .') {
                                                    delta = '.';
                                                }
                                                combinedDelta = pendingFollowUpMarkerFragment + delta;
                                                pendingFollowUpMarkerFragment = '';
                                                if (!followUpQuestionStart) {
                                                    markerIndex = combinedDelta.indexOf(FOLLOW_UP_MARKER);
                                                    if (markerIndex !== -1) {
                                                        followUpQuestionStart = true;
                                                        typingMsgBuffer.value += combinedDelta.slice(0, markerIndex);
                                                        followUpQuestions += combinedDelta.slice(markerIndex);
                                                    }
                                                    else {
                                                        carryLength = getFollowUpMarkerCarryLength(combinedDelta);
                                                        if (carryLength > 0) {
                                                            typingMsgBuffer.value += combinedDelta.slice(0, combinedDelta.length - carryLength);
                                                            pendingFollowUpMarkerFragment = combinedDelta.slice(combinedDelta.length - carryLength);
                                                        }
                                                        else {
                                                            typingMsgBuffer.value += combinedDelta;
                                                        }
                                                    }
                                                }
                                                else {
                                                    followUpQuestions += combinedDelta;
                                                }
                                                scrollToBottom();
                                                ensureTypingLoop();
                                            }
                                            else if (content.citations) {
                                                console.log('Citations', content.citations);
                                                citations = content.citations.filter(function (c) { return c.title; });
                                                citations = removeDuplicateCitations(citations);
                                                citations = citations.map(function (c) {
                                                    return {
                                                        title: c.title,
                                                        url: ensureUrlStartsWithHttps(c.url),
                                                        content: c.content,
                                                        filepath: c.filepath,
                                                    };
                                                });
                                            }
                                            else if (content.messageIds) {
                                                messages.value[msgIndex].messaggeId = content.messageIds.answerMessageId;
                                                messages.value[msgIndex - 1].messaggeId = content.messageIds.promptMessageId;
                                            }
                                            else if (content.status) {
                                                responseStatus.value = content.status;
                                            }
                                            return [3 /*break*/, 4];
                                        case 1:
                                            stopTypingLoop();
                                            if (!followUpQuestionStart && pendingFollowUpMarkerFragment) {
                                                typingMsgBuffer.value += pendingFollowUpMarkerFragment;
                                                pendingFollowUpMarkerFragment = '';
                                            }
                                            if (!audioEnabled.value) return [3 /*break*/, 3];
                                            return [4 /*yield*/, startAudioStream(typingMsgBuffer.value)];
                                        case 2:
                                            _a.sent();
                                            _a.label = 3;
                                        case 3:
                                            finishTyping(typeIndex, msgIndex, followUpQuestions, citations);
                                            followUpQuestionStart = false;
                                            followUpQuestions = '';
                                            _a.label = 4;
                                        case 4: return [3 /*break*/, 6];
                                        case 5:
                                            error_1 = _a.sent();
                                            console.error('Error streaming response', error_1);
                                            systemMessage.value = {
                                                content: 'Failed to connect to chatbot. Please reload the page and try again.',
                                                type: 'error',
                                            };
                                            return [3 /*break*/, 6];
                                        case 6: return [2 /*return*/];
                                    }
                                });
                            }); });
                            source.addEventListener('error', function (e) {
                                console.error('Error', e);
                                systemMessage.value = {
                                    content: 'Failed to connect to chatbot. Please reload the page and try again.',
                                    type: 'error',
                                };
                            });
                            source.addEventListener('keep-alive', function () {
                                console.log('Keep-alive');
                            });
                            // Yes, the browser's EventSource (used by SSE) supports a "close" event in the sense that you can listen for connection closures via the 'onclose' property, but it is not dispatched as a custom event name like "open", "message", or "error". 
                            // In practice, you can detect closure by using the 'onerror' handler (already present above), or explicitly via source.onclose = handler (but most implementations don't fire an 'onclose' event, just 'onerror' and then closed state).
                            // If you want to take action when the connection is closed (for example, when source.readyState becomes 2), you can use 'onerror' or poll source.readyState, as shown below:
                            // Optionally, observe the connection and act on closure:
                            source.onopen = function () {
                                console.log('EventSource connection established');
                            };
                            source.addEventListener('close', function () {
                                console.log('EventSource connection closed');
                            });
                            source.onerror = function (e) {
                                console.log('EventSource connection error', e);
                            };
                            source.onreadystatechange = function () {
                                console.log('EventSource readystatechange', source.readyState);
                            };
                            source.stream();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function removeDuplicateCitations(citations) {
            var unique = new Map();
            citations === null || citations === void 0 ? void 0 : citations.forEach(function (obj) { return unique.set(obj.title, obj); });
            return Array.from(unique.values());
        }
        function ensureUrlStartsWithHttps(url) {
            if (!url) {
                return '';
            }
            if (url.startsWith('http://')) {
                return url.replace('http://', 'https://');
            }
            if (!url.startsWith('http')) {
                return 'https://' + url;
            }
            return url;
        }
        function getFollowUpMarkerCarryLength(chunk) {
            var carryLength = 0;
            for (var i = chunk.length - 1; i >= 0 && carryLength < FOLLOW_UP_MARKER_PREFIX_LENGTH; i -= 1) {
                if (chunk[i] === '[') {
                    carryLength += 1;
                }
                else {
                    break;
                }
            }
            return carryLength;
        }
        function typeOneChar(index, from, toChatMsgIndex) {
            messages.value[toChatMsgIndex].content += from.charAt(index);
        }
        function finishTyping(index, toMsgIndex, followUpQuestions, citations) {
            if (citations === void 0) { citations = []; }
            if (flushTypingMsgBuffer.value) {
                messages.value[toMsgIndex].content = typingMsgBuffer.value;
                index = typingMsgBuffer.value.length - 1;
                flushTypingMsgBuffer.value = false;
            }
            if (index < typingMsgBuffer.value.length) {
                messages.value[toMsgIndex].content += typingMsgBuffer.value.charAt(index);
                setTimeout(function () { return finishTyping(index + 1, toMsgIndex, followUpQuestions, citations); }, 20);
            }
            else {
                // wer'e done
                typingMsgBuffer.value = '';
                if (followUpQuestions) {
                    var regex = /\[\[\[(.*?)\]\]\]/g;
                    var questions = [];
                    var match = regex.exec(followUpQuestions);
                    while (match !== null) {
                        questions.push(match[1]);
                        match = regex.exec(followUpQuestions);
                    }
                    messages.value[toMsgIndex].followUpQuestions = questions;
                    followUpQuestions = '';
                }
                if (citations.length) {
                    messages.value[toMsgIndex].citations = citations;
                }
                messages.value[toMsgIndex].streamResponseDone = true;
                streamResponseDone.value = true;
            }
            scrollToBottom();
        }
        (0, vue_3.onMounted)(function () {
            var _a;
            checkIfMobile();
            window.addEventListener('resize', checkIfMobile);
            setInitialViewSize();
            (_a = chatMessages.value) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', function () {
                if (chatMessages.value) {
                    isScrolledToBottom.value = chatMessages.value.scrollHeight - chatMessages.value.clientHeight <= chatMessages.value.scrollTop + 1;
                }
            });
        });
        window.addEventListener('resize', function () {
            scrollToBottom(true);
        });
        function checkIfMobile() {
            isMobile.value = window.innerWidth <= 768;
        }
        function setInitialViewSize() {
            if (embed) {
                chatViewSize.value = 'maximized';
            }
            else {
                var chatViewSizeCookie = getCookie('viewSize');
                var minimizedCookie = getCookie('minimized') === 'true';
                if (!chatViewSizeCookie) {
                    chatViewSize.value = (instance === null || instance === void 0 ? void 0 : instance.appContext.config.globalProperties.$viewSize) || 'small';
                    setCookie('viewSize', chatViewSize.value || 'small');
                }
                else {
                    chatViewSize.value = chatViewSizeCookie;
                    chatViewHidden.value = minimizedCookie;
                }
            }
        }
        function scrollToBottom(force) {
            if (force === void 0) { force = false; }
            (0, vue_3.nextTick)(function () {
                if (chatMessages.value) {
                    if (isScrolledToBottom.value || force) {
                        chatMessages.value.scrollTop = chatMessages.value.scrollHeight;
                    }
                }
            });
        }
        ;
        function minimize() {
            chatViewSize.value = 'small';
            setCookie('viewSize', 'small');
            scrollToBottom();
        }
        ;
        function hideChatWindow() {
            chatViewHidden.value = true;
            setCookie('minimized', 'true');
        }
        ;
        function maximize() {
            chatViewSize.value = 'maximized';
            setCookie('viewSize', 'maximized');
            scrollToBottom();
        }
        ;
        function showChatWindow() {
            chatViewHidden.value = false;
            setCookie('minimized', 'false');
            scrollToBottom();
        }
        ;
        function signIn() {
            return __awaiter(this, void 0, void 0, function () {
                var currentUser, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 4, , 5]);
                            return [4 /*yield*/, (0, vuefire_1.getCurrentUser)()];
                        case 1:
                            currentUser = _a.sent();
                            if (!!currentUser) return [3 /*break*/, 3];
                            return [4 /*yield*/, (0, auth_1.signInAnonymously)(auth)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [3 /*break*/, 5];
                        case 4:
                            error_2 = _a.sent();
                            console.debug('error.code', error_2.code);
                            if (error_2.code === 'auth/firebase-app-check-token-is-invalid.') {
                                appCheckFailed.value = true;
                                console.error('Firebase app check failed', error_2);
                            }
                            else {
                                console.error('Error signing in anonymously', JSON.stringify(error_2));
                            }
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        ;
        // styling stuff
        var mediaQuery = window.matchMedia('(max-width: 768px)');
        mediaQuery.addEventListener('change', handleMediaChange);
        handleMediaChange(mediaQuery);
        function handleMediaChange(e) {
            if (e.matches) {
                smallScreen.value = true;
            }
            else {
                smallScreen.value = false;
            }
        }
        function onFeedback(feedback, answerId) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var thumbsUpIconEl, thumbsDownIconEl, _b, _c, _d, _e;
                var _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            if (!answerId) return [3 /*break*/, 2];
                            thumbsUpIconEl = document.getElementById("thumbsUpIcon-".concat(answerId));
                            thumbsDownIconEl = document.getElementById("thumbsDownIcon-".concat(answerId));
                            if (feedback === 'good') {
                                thumbsUpIconEl === null || thumbsUpIconEl === void 0 ? void 0 : thumbsUpIconEl.classList.remove('pi-thumbs-up');
                                thumbsUpIconEl === null || thumbsUpIconEl === void 0 ? void 0 : thumbsUpIconEl.classList.add('pi-thumbs-up-fill');
                                thumbsDownIconEl === null || thumbsDownIconEl === void 0 ? void 0 : thumbsDownIconEl.classList.remove('pi-thumbs-down-fill');
                                thumbsDownIconEl === null || thumbsDownIconEl === void 0 ? void 0 : thumbsDownIconEl.classList.add('pi-thumbs-down');
                            }
                            else {
                                thumbsDownIconEl === null || thumbsDownIconEl === void 0 ? void 0 : thumbsDownIconEl.classList.remove('pi-thumbs-down');
                                thumbsDownIconEl === null || thumbsDownIconEl === void 0 ? void 0 : thumbsDownIconEl.classList.add('pi-thumbs-down-fill');
                                thumbsUpIconEl === null || thumbsUpIconEl === void 0 ? void 0 : thumbsUpIconEl.classList.remove('pi-thumbs-up-fill');
                                thumbsUpIconEl === null || thumbsUpIconEl === void 0 ? void 0 : thumbsUpIconEl.classList.add('pi-thumbs-up');
                            }
                            _b = fetch;
                            _c = ["".concat(url, "/answers/").concat(answerId, "/feedback")];
                            _f = {
                                method: 'PUT'
                            };
                            _g = {
                                'Content-Type': 'application/json'
                            };
                            _d = 'Authorization';
                            _e = "Bearer ".concat;
                            return [4 /*yield*/, ((_a = user.value) === null || _a === void 0 ? void 0 : _a.getIdToken())];
                        case 1:
                            _b.apply(void 0, _c.concat([(_f.headers = (_g[_d] = _e.apply("Bearer ", [_h.sent()]),
                                    _g),
                                    _f.body = JSON.stringify({
                                        feedback: feedback,
                                    }),
                                    _f)]));
                            _h.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        function onCitation(answerId, index) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var _b, _c, _d, _e;
                var _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            if (!answerId) {
                                return [2 /*return*/];
                            }
                            if (isMobile.value) {
                                hideChatWindow();
                            }
                            _b = fetch;
                            _c = ["".concat(url, "/answers/").concat(answerId, "/metrics")];
                            _f = {
                                method: 'PUT'
                            };
                            _g = {
                                'Content-Type': 'application/json'
                            };
                            _d = 'Authorization';
                            _e = "Bearer ".concat;
                            return [4 /*yield*/, ((_a = user.value) === null || _a === void 0 ? void 0 : _a.getIdToken())];
                        case 1:
                            _b.apply(void 0, _c.concat([(_f.headers = (_g[_d] = _e.apply("Bearer ", [_h.sent()]),
                                    _g),
                                    _f.body = JSON.stringify({
                                        citationClick: index,
                                    }),
                                    _f)]));
                            return [2 /*return*/];
                    }
                });
            });
        }
        function onFollowUpQuestion(answerId, index) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var _b, _c, _d, _e;
                var _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            if (!answerId) {
                                return [2 /*return*/];
                            }
                            _b = fetch;
                            _c = ["".concat(url, "/answers/").concat(answerId, "/metrics")];
                            _f = {
                                method: 'PUT'
                            };
                            _g = {
                                'Content-Type': 'application/json'
                            };
                            _d = 'Authorization';
                            _e = "Bearer ".concat;
                            return [4 /*yield*/, ((_a = user.value) === null || _a === void 0 ? void 0 : _a.getIdToken())];
                        case 1:
                            _b.apply(void 0, _c.concat([(_f.headers = (_g[_d] = _e.apply("Bearer ", [_h.sent()]),
                                    _g),
                                    _f.body = JSON.stringify({
                                        followUpQuestionClick: index,
                                    }),
                                    _f)]));
                            return [2 /*return*/];
                    }
                });
            });
        }
        function toggleAudio() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/];
                });
            });
        }
        // async function stopAudio() {
        //     if (mediaRecorder.value && mediaRecorder.value.state === "recording") {
        //         mediaRecorder.value.stop();
        //         systemMessage.value = undefined;
        //     }
        // }
        // async function setupMicIfNotDone() {
        //     if (!speech.value) {
        //         systemMessage.value = {
        //             content: 'Connecting to microphone...',
        //             type: 'info',
        //         };
        //         const stream = await getMicrophoneAccess();
        //         if (!stream) {
        //             systemMessage.value = {
        //                 content: 'Microphone access denied.',
        //                 type: 'error',
        //             };
        //             return;
        //         }
        //         mediaRecorder.value = await createMediaRecorder(stream, transcribeAndSendMessage)
        //         speech.value = hark(stream, {
        //             threshold: -40,
        //             interval: 100,
        //         });
        //         speech.value.on('speaking', async () => {
        //             console.log('speaking, audio status', audioStatus.value, 'media recorder state', mediaRecorder.value?.state);
        //             const audio = document.getElementById('audioPlayer') as HTMLAudioElement;
        //             audio.pause();
        //             if (!streamResponseDone.value) {
        //                 flushTypingMsgBuffer.value = true;
        //             }
        //             if (audioStatus.value === 'idle' || audioStatus.value === 'playing') {
        //                 showCursor.value = true;
        //                 messages.value.push({
        //                         content: '',
        //                         role: 'user',
        //                         id: messages.value.length,
        //                         streamResponseDone: false
        //                     }
        //                 );
        //                 if (mediaRecorder.value?.state === 'inactive') {
        //                     mediaRecorder.value.start(100);
        //                 }
        //                 audioStatus.value = 'recording';
        //             }
        //         });
        //         speech.value.on('stopped_speaking', () => {
        //             console.log('stopped speaking, audio status', audioStatus.value);
        //             if (audioStatus.value === 'recording') {
        //                 if (mediaRecorder.value?.state === 'recording') {
        //                     mediaRecorder.value?.stop();
        //                 }
        //                 systemMessage.value = undefined;
        //             }
        //         });
        //         systemMessage.value = {
        //             content: 'Ready. Speak now.',
        //             type: 'info',
        //         };
        //         mediaRecorder.value.start(100);
        //     }
        // }
        // async function getMicrophoneAccess() {
        //     try {
        //         const constraints = { audio: true };
        //         const stream = await navigator.mediaDevices.getUserMedia(constraints);
        //         console.log('Microphone access granted.', stream);
        //         return stream;
        //     } catch (error) {
        //         audioStatus.value = 'error';
        //         systemMessage.value = {
        //             content: 'Failed to connect to microphone. Please reload the page and try again.',
        //             type: 'error',
        //         };
        //         console.error('Microphone access denied:', error);
        //         return null;
        //     }
        // }
        // async function createMediaRecorder(stream: MediaStream, transcribeAndSendMessage: (audioChunks: Blob[], mimeType: string) => Promise<void>) {
        //     const preferredMimeType = 'audio/webm';
        //     let audioChunks: Blob[] = [];
        //     let mediaRecorder: MediaRecorder;
        //     if (MediaRecorder.isTypeSupported(preferredMimeType)) {
        //         mediaRecorder = new MediaRecorder(stream, { mimeType: preferredMimeType });
        //     } else {
        //         mediaRecorder = new MediaRecorder(stream);
        //     }
        //     mediaRecorder.ondataavailable = (event) => {
        //         if (event.data.size > 0) {
        //             audioChunks.push(event.data);
        //         }
        //     };
        //     mediaRecorder.onstop = async() => {
        //         await transcribeAndSendMessage(audioChunks, mediaRecorder.mimeType);
        //         audioChunks = [];
        //         mediaRecorder.start(100);
        //     };
        //     return mediaRecorder;
        // }
        function transcribeAndSendMessage(audioChunks, mimeType) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var audioBlob, formData, response, _b, _c, _d, _e, data, error_3;
                var _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            // console.log('Transcribing audio...', audioChunks.length, 'chunks');
                            audioStatus.value = 'transcribing';
                            audioBlob = new Blob(audioChunks, { type: mimeType });
                            formData = new FormData();
                            formData.append('audio', audioBlob);
                            _h.label = 1;
                        case 1:
                            _h.trys.push([1, 5, , 6]);
                            _b = fetch;
                            _c = ["".concat(url, "/transcriptions")];
                            _f = {
                                method: 'POST',
                                body: formData
                            };
                            _g = {};
                            _d = 'Authorization';
                            _e = 'Bearer ';
                            return [4 /*yield*/, ((_a = user.value) === null || _a === void 0 ? void 0 : _a.getIdToken())];
                        case 2: return [4 /*yield*/, _b.apply(void 0, _c.concat([(_f.headers = (_g[_d] = _e + (_h.sent()),
                                    _g),
                                    _f)]))];
                        case 3:
                            response = _h.sent();
                            if (!response.ok) {
                                throw new Error('Failed to transcribe audio');
                            }
                            return [4 /*yield*/, response.json()];
                        case 4:
                            data = _h.sent();
                            // messages.value[messages.value.length - 1].content = data.text;
                            messages.value.pop();
                            sendMessage(data.text);
                            return [3 /*break*/, 6];
                        case 5:
                            error_3 = _h.sent();
                            audioStatus.value = 'error';
                            console.error('Failed to send audio:', error_3);
                            systemMessage.value = {
                                content: 'Failed to transcribe audio to text. Reload the page and try again.',
                                type: 'error',
                            };
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        }
        function startAudioStream(text) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var streamUrl, _b, _c, audio, error_4;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 3, , 4]);
                            // console.log('Playing audio:', text);
                            audioStatus.value = 'playing';
                            _c = (_b = "".concat(url, "/tts?text=").concat(encodeURIComponent(text), "&authToken=")).concat;
                            return [4 /*yield*/, ((_a = user.value) === null || _a === void 0 ? void 0 : _a.getIdToken())];
                        case 1:
                            streamUrl = _c.apply(_b, [_d.sent()]);
                            audio = document.getElementById('audioPlayer');
                            audio.src = streamUrl;
                            // console.log('Audio source:', audio.src);
                            audio.load();
                            return [4 /*yield*/, audio.play()];
                        case 2:
                            _d.sent();
                            audio.onended = function () {
                                audioStatus.value = 'idle';
                                systemMessage.value = undefined;
                                // console.log('Audio ended.');
                            };
                            systemMessage.value = {
                                content: 'Speak to interrupt the audio.',
                                type: 'info',
                            };
                            return [3 /*break*/, 4];
                        case 3:
                            error_4 = _d.sent();
                            audioStatus.value = 'error';
                            console.error('Failed to play audio:', error_4);
                            systemMessage.value = {
                                content: 'Failed to play audio. Reload the page and try again.',
                                type: 'error',
                            };
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g;
            var _component_Avatar = (0, vue_2.resolveComponent)("Avatar");
            var _component_PrimeButton = (0, vue_2.resolveComponent)("PrimeButton");
            var _component_InlineMessage = (0, vue_2.resolveComponent)("InlineMessage");
            var _component_Card = (0, vue_2.resolveComponent)("Card");
            var _component_PrimeTextarea = (0, vue_2.resolveComponent)("PrimeTextarea");
            var _directive_tooltip = (0, vue_2.resolveDirective)("tooltip");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _hoisted_2,
                (!invalidBotId.value && (0, vue_2.unref)(botId) && !appCheckFailed.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                        (chatViewHidden.value)
                            ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_Avatar, {
                                key: 0,
                                onClick: showChatWindow,
                                class: "mr-2 chat-lower-right",
                                size: "xlarge",
                                shape: "circle",
                                style: (0, vue_2.normalizeStyle)("background-color: ".concat(primaryColor.value))
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    _hoisted_3
                                ]; }),
                                _: 1
                            }, 8, ["style"])), [
                                [
                                    _directive_tooltip,
                                    "Click to open ".concat(title.value),
                                    void 0,
                                    { left: true }
                                ]
                            ])
                            : (0, vue_2.createCommentVNode)("", true),
                        (!chatViewHidden.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 1,
                                class: (0, vue_2.normalizeClass)(["surface-card shadow-2 border-round flex flex-column chat-lower-right chatview", { 'chatview-maximized': chatViewSize.value === 'maximized' }])
                            }, [
                                (0, vue_2.createElementVNode)("div", {
                                    class: "flex align-items-center justify-content-between shadow-2",
                                    style: (0, vue_2.normalizeStyle)([{ "border-top-left-radius": "var(--border-radius)", "border-top-right-radius": "var(--border-radius)" }, "background-color: ".concat(primaryColor.value)])
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(title.value), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                        (chatViewSize.value !== 'maximized' && !smallScreen.value && !(0, vue_2.unref)(embed))
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_PrimeButton, {
                                                key: 0,
                                                onClick: maximize,
                                                class: "mt-2 mb-2 p-2 flex align-items-center justify-content-center",
                                                type: "button",
                                                style: (0, vue_2.normalizeStyle)("background-color: ".concat(primaryColor.value, "; border-color:  ").concat(primaryColor.value))
                                            }, {
                                                default: (0, vue_2.withCtx)(function () { return [
                                                    _hoisted_6
                                                ]; }),
                                                _: 1
                                            }, 8, ["style"]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (chatViewSize.value === 'maximized' && !smallScreen.value && !(0, vue_2.unref)(embed))
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_PrimeButton, {
                                                key: 1,
                                                onClick: minimize,
                                                class: "mt-2 mb-2 p-2 flex align-items-center justify-content-center",
                                                type: "button",
                                                style: (0, vue_2.normalizeStyle)("background-color: ".concat(primaryColor.value, "; border-color:  ").concat(primaryColor.value))
                                            }, {
                                                default: (0, vue_2.withCtx)(function () { return [
                                                    _hoisted_7
                                                ]; }),
                                                _: 1
                                            }, 8, ["style"]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (!(0, vue_2.unref)(embed))
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_PrimeButton, {
                                                key: 2,
                                                onClick: hideChatWindow,
                                                class: "mt-2 mb-2 p-2 flex align-items-center justify-content-center",
                                                type: "button",
                                                style: (0, vue_2.normalizeStyle)("background-color: ".concat(primaryColor.value, "; border-color:  ").concat(primaryColor.value))
                                            }, {
                                                default: (0, vue_2.withCtx)(function () { return [
                                                    _hoisted_8
                                                ]; }),
                                                _: 1
                                            }, 8, ["style"]))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ])
                                ], 4),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["flex flex-column flex-grow-1 p-3", { 'pb-1': !((_b = (_a = chatbot.value) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.removeAspiireMention) }])
                                }, [
                                    (0, vue_2.createElementVNode)("div", {
                                        ref_key: "chatMessages",
                                        ref: chatMessages,
                                        class: (0, vue_2.normalizeClass)(["flex flex-column flex-grow-1 gap-3 pb-4", "chatwindow-".concat(chatViewSize.value)])
                                    }, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(messages.value, function (msg) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_Card, {
                                                key: msg.id,
                                                class: (0, vue_2.normalizeClass)(["flex w-11", msg.role === 'user' ? 'user-message' : '']),
                                                style: (0, vue_2.normalizeStyle)("background-color: ".concat(msg.role === 'user' ? primaryColorLight : 'white')),
                                                pt: { content: { class: 'p-0' } }
                                            }, {
                                                content: (0, vue_2.withCtx)(function () {
                                                    var _a, _b, _c, _d, _e, _f, _g, _h;
                                                    return [
                                                        (0, vue_2.createElementVNode)("div", {
                                                            class: "marked-content",
                                                            innerHTML: (0, vue_2.unref)(marked_1.marked)(msg.content)
                                                        }, null, 8, _hoisted_9),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                                            (msg.id === (messages.value.length - 1) && showCursor.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11))
                                                                : (0, vue_2.createCommentVNode)("", true),
                                                            (msg.id === (messages.value.length - 1) && (responseStatus.value === 'in_progress' || responseStatus.value === 'web_search_in_progress') && showCursor.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, (0, vue_2.toDisplayString)(responseStatus.value === 'in_progress' ? 'Searching...' : (responseStatus.value === 'web_search_in_progress' ? 'Thinking...' : '')), 1))
                                                                : (0, vue_2.createCommentVNode)("", true)
                                                        ]),
                                                        (msg.role === 'assistant' && msg.id !== 0 && ((_b = (_a = chatbot.value) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.feedback) && !!msg.streamResponseDone)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                                (0, vue_2.createVNode)(_component_PrimeButton, {
                                                                    onClick: function ($event) { return (onFeedback('good', msg.messaggeId)); },
                                                                    link: "",
                                                                    title: "Good response"
                                                                }, {
                                                                    default: (0, vue_2.withCtx)(function () { return [
                                                                        (0, vue_2.createElementVNode)("span", {
                                                                            id: "thumbsUpIcon-".concat(msg.messaggeId),
                                                                            class: "pi pi-thumbs-up"
                                                                        }, null, 8, _hoisted_13)
                                                                    ]; }),
                                                                    _: 2
                                                                }, 1032, ["onClick"]),
                                                                (0, vue_2.createVNode)(_component_PrimeButton, {
                                                                    onClick: function ($event) { return (onFeedback('bad', msg.messaggeId)); },
                                                                    link: "",
                                                                    title: "Bad response"
                                                                }, {
                                                                    default: (0, vue_2.withCtx)(function () { return [
                                                                        (0, vue_2.createElementVNode)("span", {
                                                                            id: "thumbsDownIcon-".concat(msg.messaggeId),
                                                                            class: "pi pi-thumbs-down"
                                                                        }, null, 8, _hoisted_14)
                                                                    ]; }),
                                                                    _: 2
                                                                }, 1032, ["onClick"])
                                                            ], 64))
                                                            : (0, vue_2.createCommentVNode)("", true),
                                                        (((_c = msg.citations) === null || _c === void 0 ? void 0 : _c.length) && ((_e = (_d = chatbot.value) === null || _d === void 0 ? void 0 : _d.settings) === null || _e === void 0 ? void 0 : _e.citations))
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                                                                _hoisted_16,
                                                                (0, vue_2.createElementVNode)("ul", _hoisted_17, [
                                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(msg.citations, function (c, i) {
                                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                                                            onClick: function ($event) { return (onCitation(msg.messaggeId, i)); },
                                                                            class: "m-0 mb-2",
                                                                            style: { "list-style-type": "none" },
                                                                            key: c.filepath
                                                                        }, [
                                                                            (c === null || c === void 0 ? void 0 : c.url)
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                                                    key: 0,
                                                                                    href: "".concat((c === null || c === void 0 ? void 0 : c.url) || '#'),
                                                                                    target: "applied_safe",
                                                                                    innerHTML: c.title || ''
                                                                                }, null, 8, _hoisted_19))
                                                                                : (0, vue_2.createCommentVNode)("", true)
                                                                        ], 8, _hoisted_18));
                                                                    }), 128))
                                                                ])
                                                            ]))
                                                            : (0, vue_2.createCommentVNode)("", true),
                                                        (((_f = msg.followUpQuestions) === null || _f === void 0 ? void 0 : _f.length) && ((_h = (_g = chatbot.value) === null || _g === void 0 ? void 0 : _g.settings) === null || _h === void 0 ? void 0 : _h.followUpQuestions))
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_20, [
                                                                _hoisted_21,
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(msg.followUpQuestions, function (question, index) {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_InlineMessage, {
                                                                        onClick: function ($event) { onFollowUpQuestion(msg.messaggeId, index); sendMessage(question); },
                                                                        class: "p-1 follow-up-questions",
                                                                        severity: "info",
                                                                        key: index,
                                                                        pt: { icon: { style: 'display: none' } }
                                                                    }, {
                                                                        default: (0, vue_2.withCtx)(function () { return [
                                                                            (0, vue_2.createElementVNode)("i", null, (0, vue_2.toDisplayString)(question), 1)
                                                                        ]; }),
                                                                        _: 2
                                                                    }, 1032, ["onClick"]));
                                                                }), 128))
                                                            ]))
                                                            : (0, vue_2.createCommentVNode)("", true)
                                                    ];
                                                }),
                                                _: 2
                                            }, 1032, ["class", "style"]));
                                        }), 128))
                                    ], 2),
                                    (systemMessage.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                                            (0, vue_2.createElementVNode)("span", {
                                                style: (0, vue_2.normalizeStyle)("color: var(--".concat((_c = systemMessage.value) === null || _c === void 0 ? void 0 : _c.type, "-color)"))
                                            }, (0, vue_2.toDisplayString)((_d = systemMessage.value) === null || _d === void 0 ? void 0 : _d.content), 5)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                        (!isScrolledToBottom.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                key: 0,
                                                onClick: _cache[0] || (_cache[0] = function ($event) { return (scrollToBottom(true)); }),
                                                class: "pi pi-arrow-circle-down scroll-down-icon"
                                            }))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createVNode)(_component_PrimeTextarea, {
                                            onKeyup: _cache[1] || (_cache[1] = (0, vue_2.withKeys)(function ($event) { return (sendMessage()); }, ["enter"])),
                                            class: "w-full mr-1",
                                            placeholder: "Type a message",
                                            modelValue: newMessage.value,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((newMessage).value = $event); }),
                                            autoResize: "",
                                            rows: "2"
                                        }, null, 8, ["modelValue"]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                            (0, vue_2.createVNode)(_component_PrimeButton, {
                                                disabled: !streamResponseDone.value || disableSend.value,
                                                class: "w-3rem h-2rem",
                                                icon: "pi pi-send",
                                                onClick: _cache[3] || (_cache[3] = function ($event) { return (sendMessage()); }),
                                                style: (0, vue_2.normalizeStyle)("background-color: ".concat(primaryColor.value, "; border-color: ").concat(primaryColor.value))
                                            }, null, 8, ["disabled", "style"]),
                                            ((_f = (_e = chatbot.value) === null || _e === void 0 ? void 0 : _e.settings) === null || _f === void 0 ? void 0 : _f.enableAudio)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_PrimeButton, {
                                                    key: 0,
                                                    disabled: !streamResponseDone.value || disableSend.value,
                                                    class: "w-3rem h-2rem",
                                                    icon: "pi pi-microphone",
                                                    onClick: toggleAudio,
                                                    style: (0, vue_2.normalizeStyle)(styleButtonToggleAudio.value)
                                                }, null, 8, ["disabled", "style"]))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ])
                                    ]),
                                    (((_g = chatbot.value) === null || _g === void 0 ? void 0 : _g.settings) !== undefined && !chatbot.value.settings.removeAspiireMention)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, _hoisted_27))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ], 2)
                            ], 2))
                            : (0, vue_2.createCommentVNode)("", true)
                    ], 64))
                    : (appCheckFailed.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_28, [
                            (0, vue_2.createVNode)(_component_InlineMessage, {
                                severity: "error",
                                class: "m-2",
                                pt: { icon: { style: 'display: none' } }
                            }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    _hoisted_29
                                ]; }),
                                _: 1
                            })
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_30, _hoisted_32))
            ]));
        };
    }
});
